'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _modal_type = require('redux/actions/modal_type');

var _auth = require('redux/actions/auth');

var _modal = require('redux/actions/modal');

var _BaseForm2 = require('../../BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassRecoveryStepThree = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        preload: state.auth.preload,
        lang: state.lang
    };
}, { showModalAuth: _modal_type.showModalAuth, load: _auth.load, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(PassRecoveryStepThree, _BaseForm);
    (0, _createClass3.default)(PassRecoveryStepThree, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.load();
        }
    }]);

    function PassRecoveryStepThree(props) {
        (0, _classCallCheck3.default)(this, PassRecoveryStepThree);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepThree.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepThree)).call(this, props));

        _this.onShowAuth = function () {
            _this.props.showModalAuth(_this.props.lang);
        };

        _this.hideModal = function (e) {
            e.preventDefault();
            _this.props.hide();
        };

        return _this;
    }

    (0, _createClass3.default)(PassRecoveryStepThree, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('PassRecoveryStepThree', null, { folderName: "PassRecovery/PassRecoveryStepThree" });

            return _react2.default.createElement(View, {
                handleClick: this.hideModal,
                lang: this.props.lang
            });
        }
    }]);
    return PassRecoveryStepThree;
}(_BaseForm3.default), _class2.propTypes = {
    lang: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PassRecoveryStepThree;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepThree/PassRecoveryStepThree.jsx
// module id = 1723
// module chunks = 0